import { render, staticRenderFns } from "./ProfileOrdersDetailsModal.vue?vue&type=template&id=472ef0c6&scoped=true&"
import script from "./ProfileOrdersDetailsModal.vue?vue&type=script&lang=js&"
export * from "./ProfileOrdersDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./ProfileOrdersDetailsModal.vue?vue&type=style&index=0&id=472ef0c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472ef0c6",
  null
  
)

export default component.exports